import React from 'react'
import Link from '../Link/Link'

export const CheckList = (props) => {
  const { checkList } = props
  const { listItems } = checkList

  return (
    <div className='check-list'>
      <ul className='checkmark'>
        {listItems && listItems.map((listItem, key) => (
          <li key={`checkListItem${key}`}>
            {typeof listItem === 'string' ? (
              listItem
            ) : (
              <>
                {listItem.prefix}
                <Link url={listItem.url} ariaLabel={listItem.linkAriaLabel}>
                  {listItem.linkText}
                </Link>
              </>
            )}
          </li>
        ))}
      </ul>
    </div>
  )
}

export default CheckList